/*
 * Jira Ticket:
 * Created Date: Thu, 26th Mar 2020, 13:25:22 pm
 * Author: Jessica Mowatt
 * Email: jessica.mowatt@thedistance.co.uk
 * Copyright (c) 2020 The Distance
 */

import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  TopToolbar,
  CreateButton,
  sanitizeListRestProps,
  useDataProvider,
} from 'react-admin';
import { Help } from '@material-ui/icons';
import { ActionButton } from 'Components/Buttons';
import getHelp from '../../utils/getHelp';

const TowerTypeActions = ({
  currentSort,
  className,
  resource,
  filters,
  displayedFilters,
  exporter = false, // you can hide ExportButton if exporter = (null || false)
  filterValues,
  permanentFilter,
  hasCreate, // you can hide CreateButton if hasCreate = false
  basePath,
  selectedIds,
  onUnselectItems,
  showFilter,
  maxResults,
  total,
  ...rest
}) => {
  const dataProvider = useDataProvider();
  const dispatch = useDispatch();
  const [helpLink, setHelpLink] = useState();

  const useMountEffect = fun => useEffect(fun, []);
  useMountEffect(
    getHelp('help_url_tower_type', { dataProvider, dispatch, setHelpLink })
  ); // run once

  return (
    <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
      {helpLink && (
        <ActionButton
          label="resources.General.help"
          variant="text"
          onClick={() => {
            window.open(helpLink);
          }}
          icon={<Help />}
        />
      )}
      <CreateButton basePath={basePath} />
    </TopToolbar>
  );
};

TowerTypeActions.defaultProps = {
  selectedIds: [],
  onUnselectItems: () => null,
};

export default TowerTypeActions;
